import type * as Types from 'app/types/graphql';

import {
  ShopPlatformPlanEdgeSelectFragmentDoc,
  ShopPlatformPlanSelectFragmentDoc,
} from '../fragments/shopPlatformPlan.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { PlanSelectFragmentDoc } from '../fragments/plan.generated';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformPlansQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ShopPlatformPlanWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.ShopPlatformPlanOrder>>;
}>;

export type ShopPlatformPlansQueryResponse = {
  shopPlatformPlans?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<{
        node?: Types.Maybe<
          Pick<
            Types.ShopPlatformPlan,
            'id' | 'planID' | 'confirmationURL' | 'startDate' | 'endDate' | 'status'
          > & {
            plan?: Types.Maybe<
              Pick<
                Types.Plan,
                | 'id'
                | 'name'
                | 'displayName'
                | 'priority'
                | 'isTrial'
                | 'basePrice'
                | 'billingCycle'
                | 'deprecated'
                | 'conditions'
                | 'createdAt'
                | 'updatedAt'
                | 'trialDays'
              >
            >;
          }
        >;
      }>
    >;
  }>;
};

export const ShopPlatformPlansDocument = `
    query ShopPlatformPlans($first: Int, $where: ShopPlatformPlanWhereInput, $orderBy: [ShopPlatformPlanOrder!]) {
  shopPlatformPlans(first: $first, where: $where, orderBy: $orderBy) {
    ...ShopPlatformPlanEdgeSelect
  }
}
    ${ShopPlatformPlanEdgeSelectFragmentDoc}
${ShopPlatformPlanSelectFragmentDoc}
${PlanSelectFragmentDoc}`;

export const useShopPlatformPlansQuery = <TData = ShopPlatformPlansQueryResponse, TError = unknown>(
  variables?: ShopPlatformPlansQueryVariables,
  options?: UseQueryOptions<ShopPlatformPlansQueryResponse, TError, TData>,
) => {
  return useQuery<ShopPlatformPlansQueryResponse, TError, TData>(
    variables === undefined ? ['ShopPlatformPlans'] : ['ShopPlatformPlans', variables],
    appFetcher<ShopPlatformPlansQueryResponse, ShopPlatformPlansQueryVariables>(
      ShopPlatformPlansDocument,
      variables,
    ),
    options,
  );
};

useShopPlatformPlansQuery.getKey = (variables?: ShopPlatformPlansQueryVariables) =>
  variables === undefined ? ['ShopPlatformPlans'] : ['ShopPlatformPlans', variables];
